import { IconComponent } from './types';

const FarmBoundaryIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.16913 0.5H11.5V5.5H9.00001H8.50001V6V11.5H6.00002H0.500033L0.500001 4.83083L6.16913 0.5Z"
      stroke="currentColor"
    />
  </svg>
);

export default FarmBoundaryIcon;
